import api from "./api";

// Modelos de assinatura de e-mail (múltiplos modelos nomeados por empresa).
const signatureService = {
  listTemplates: () => api.get("/signatures/templates").then((r) => r.data),
  getTemplate: (id) => api.get(`/signatures/template/${id || "default"}`).then((r) => r.data),
  createTemplate: (html, name) => api.post("/signatures/templates", { html, name }).then((r) => r.data),
  deleteTemplate: (id) => api.delete(`/signatures/templates/${id}`),
};

export default signatureService;
